import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class Login extends Component {

    componentDidMount() {
         localStorage.setItem("templink","/room")
        window.location.replace("https://mazaraat.org/#/"+(localStorage.mn ===undefined ? "":localStorage.mn)); 
        // window.location.replace("/");
        localStorage.removeItem('mn');
       
    }
   
    render() {
        return <></>;
                
    }
}

export default Login;

